import script from "./MoreText.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoreText.vue?vue&type=script&lang=ts&setup=true"

import "./MoreText.vue?vue&type=style&index=0&id=5b9ba320&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b9ba320"]])

export default __exports__